import Init from './Initer';
import PW_Form from '_premierworld/js/Classes/Form';

Init.addRegister('form', PW_Form.initializeMultiple, PW_Form);